const { appLogDebug } = require('./core/core.logger');
const { BdcaPremija } = require('./bdca/bdca.premija');
const { prvadiagnoza202204Model, getPrvadiagnoza202204Model } = require('./models/prvadiagnoza202204/prvadiagnoza202204.model');
const { getVstopSSvetovanjemStrankaPrisotnaForm } = require('./models/VstopSSvetovanjemStrankaPrisotnaForm/VstopSSvetovanjemStrankaPrisotnaForm.model');
const { getPricesForPrvaDiagnoza } = require('./models/prvadiagnoza202204/izacun-premije');
const { validatePrvadiagnoza202204 } = require('./models/prvadiagnoza202204/validate');
const { getZacetekZavarovanjaPrvaDiagnoza202204 } = require('./models/prvadiagnoza202204/zacetekZavarovanja');
const { validateVstopSSvetovanjemStrankaPrisotna } = require('./models/VstopSSvetovanjemStrankaPrisotnaForm/validate');
const { 
    validateTextInput,
    validateEmailInput,
    getSuggestionBasedOnIBAN,
    isValidIBAN,
    validateIBANInput,
    validateZipCodeInput,
    validateVatId1,
    validateDateInput,
    validateTnsDaNe,
    validateRadioDANERequiredDAField,
    validateRadioMultipleField,
    validateGenderInput,
    validateRadioDANEWithExtraDataIfDA,
    validateAddressInputGroup,
    validateCheckboxRequiredChecked,
    validateCheckbox,
    validateFormField,
    validatePotrditvenaKoda,
} = require('./validation/validation');
const { validateVatId } = require('./core/core.validator');


const __EUREKO_LIB_VERSION__ = '0.0.1';

const testLibrary = () => {
    console.debug("I am testing library");
};

// ----

module.exports = {
    __EUREKO_LIB_VERSION__,
    testLibrary,
    appLogDebug,
    BdcaPremija,
    prvadiagnoza202204Model,    // TODO - remove
    validateTextInput,
    validateEmailInput,
    getSuggestionBasedOnIBAN,
    isValidIBAN,
    validateIBANInput,
    validateZipCodeInput,
    validateVatId1,
    validateDateInput,
    validateTnsDaNe,
    validateRadioDANERequiredDAField,
    validateRadioMultipleField,
    validateGenderInput,
    validateRadioDANEWithExtraDataIfDA,
    validateAddressInputGroup,
    validateCheckboxRequiredChecked,
    validateCheckbox,
    validateFormField,
    validatePrvadiagnoza202204,
    getPricesForPrvaDiagnoza,
    getPrvadiagnoza202204Model,
    validateVatId,
    getVstopSSvetovanjemStrankaPrisotnaForm,
    validateVstopSSvetovanjemStrankaPrisotna,
    validatePotrditvenaKoda,
    getZacetekZavarovanjaPrvaDiagnoza202204,
};



